// This enum is used to map filter keys from URL to API filter keys
export enum FilterMapping {
  PROJECT_TYPES = 'has_type][ids][',
  PROJECT_STATES = 'states][',
  PROJECT_STATE = 'state',
  WORKFLOW_TYPES = 'has_flow][flow_template_ids][',
  CREATED_BEFORE = 'has_flow][created_before]',
  CREATED_AFTER = 'has_flow][created_after]',

  VENDOR_CATEGORY_IDS = 'category_ids][',

  WORKFLOW_TYPES_FLOWS = 'flow_template_ids][',
  CREATED_BEFORE_FLOWS = 'created_before]',
  CREATED_AFTER_FLOWS = 'created_after]',

  CREATED_BEFORE_REQUESTS = 'created_before',
  CREATED_AFTER_REQUESTS = 'created_after',
  COMPLETED_BEFORE_REQUESTS = 'completed_before',
  COMPLETED_AFTER_REQUESTS = 'completed_after',
  ASSIGNABLE_TYPE = 'assignable][type][',
  ASSIGNABLE_ID = 'assignable][id][',
  EXPIRED_AT_BEFORE = 'sla_exceeded',
  HAS_FLOW_PROJECT_IDS = 'has_flow][projects][',
  PROJECT_IDS = 'projects][',
  STEP_HAS_FLOW_PROJECT_IDS = 'step][has_flow][projects][',
  ASSIGNEES_TYPE = 'assignees][assignable_type]',
  ASSIGNEES_IDS = 'assignees][assignable_ids][',
  ASSIGNABLE_TYPE_PLAIN = 'assignable_type',
  ASSIGNABLE_IDS_ARRAY = 'assignable_ids][]',
  CURRENT_ASSIGNEES_TYPE = 'current_assignees][assignable_type]',
  CURRENT_ASSIGNEES_IDS = 'current_assignees][assignable_ids][]',
}
